import type { RouterOutputs } from "@utils/trpc";

export type CollectionId = string;
export type SongId = string;

export type CatalogSong = RouterOutputs["catalog"]["songs"]["getById"][number];

/**
 * Player-native song type.
 *
 * NOTE: For UI compatibility during migration, the player also attaches
 * a queue-specific id elsewhere (queueItemId / songQueueId).
 */
export type Song = CatalogSong;

export type ForYou = {
  id: string;
};

export type Collection =
  | { type: "album"; album: { id: string; title?: string }; songs: Song[] }
  | { type: "artist"; artist: { id: string; name?: string }; songs: Song[] }
  | {
      type: "playlist";
      playlist: { id: string; title?: string };
      songs: Song[];
    }
  | { type: "foryou"; foryou: ForYou; songs: Song[] };

export type CollectionType = Collection["type"];

// Catalog-backed collections (i.e. "real" collections, not the ForYou feed).
export type CatalogCollectionType = Exclude<CollectionType, "foryou">;
